"use strict";

var _regeneratorRuntime = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/aaron/projects/ual-anchor-demo/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var universal_authenticator_library_1 = require("universal-authenticator-library");

var anchor_link_1 = __importDefault(require("anchor-link"));

var interfaces_1 = require("./interfaces");

var AnchorUser_1 = require("./AnchorUser");

var AnchorLogo_1 = require("./AnchorLogo");

var UALAnchorError_1 = require("./UALAnchorError");

var anchor_link_browser_transport_1 = __importDefault(require("anchor-link-browser-transport"));

var Anchor =
/*#__PURE__*/
function (_universal_authentica) {
  _inherits(Anchor, _universal_authentica);

  /**
   * Anchor Constructor.
   *
   * @param chains
   * @param options { appName } appName is a required option to use Scatter
   */
  function Anchor(chains, options) {
    var _this;

    _classCallCheck(this, Anchor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Anchor).call(this, chains)); // Storage for AnchorUser instances

    _this.users = []; // Establish initial values

    _this.chainId = chains[0].chainId;
    _this.service = options.service || 'https://cb.anchor.link';
    _this.users = []; // Determine the default rpc endpoint for this chain

    var _chains = _slicedToArray(chains, 1),
        chain = _chains[0];

    var _chain$rpcEndpoints = _slicedToArray(chain.rpcEndpoints, 1),
        rpc = _chain$rpcEndpoints[0];

    _this.rpc = "".concat(rpc.protocol, "://").concat(rpc.host, ":").concat(rpc.port); // Ensure the appName is set properly

    if (options && options.appName) {
      _this.appName = options.appName;
    } else {
      throw new UALAnchorError_1.UALAnchorError('ual-anchor requires the appName property to be set on the `options` argument during initialization.', universal_authenticator_library_1.UALErrorType.Initialization, null);
    } // Allow overriding the JsonRpc client


    if (options && options.rpc) {
      var _rpc = options.rpc; // A hack for eosjs to resolve the "illegal invocation" errors while fetching
      //    this can be removed in the future once the issue is resolve in anchor-link, but shouldn't cause harm in the mean time

      if (_rpc.fetchBuiltin) {
        _rpc.fetchBuiltin = _rpc.fetchBuiltin.bind(window);
      }

      _this.rpc = _rpc;
    }

    return _this;
  }
  /**
   * Called after `shouldRender` and should be used to handle any async actions required to initialize the authenticator
   */


  _createClass(Anchor, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var session;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // establish anchor-link
                this.link = new anchor_link_1.default({
                  chainId: this.chainId,
                  rpc: this.rpc,
                  service: this.service,
                  transport: new anchor_link_browser_transport_1.default({
                    // disable browser transport UI status messages, ual has its own
                    requestStatus: false
                  })
                }); // attempt to restore any existing session for this app

                _context.next = 3;
                return this.link.restoreSession(this.appName);

              case 3:
                session = _context.sent;

                if (session) {
                  this.users = [new AnchorUser_1.AnchorUser(this.rpc, session)];
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Resets the authenticator to its initial, default state then calls `init` method
     */

  }, {
    key: "reset",
    value: function reset() {
      this.users = [];
    }
    /**
     * Returns true if the authenticator has errored while initializing.
     */

  }, {
    key: "isErrored",
    value: function isErrored() {
      return false;
    }
    /**
     * Returns a URL where the user can download and install the underlying authenticator
     * if it is not found by the UAL Authenticator.
     */

  }, {
    key: "getOnboardingLink",
    value: function getOnboardingLink() {
      return 'https://github.com/greymass/anchor/';
    }
    /**
     * Returns error (if available) if the authenticator has errored while initializing.
     */

  }, {
    key: "getError",
    value: function getError() {
      return null;
    }
    /**
     * Returns true if the authenticator is loading while initializing its internal state.
     */

  }, {
    key: "isLoading",
    value: function isLoading() {
      return false;
    }
    /**
     * Returns the style of the Button that will be rendered.
     */

  }, {
    key: "getStyle",
    value: function getStyle() {
      return {
        icon: AnchorLogo_1.AnchorLogo,
        text: interfaces_1.Name,
        textColor: 'white',
        background: '#3650A2'
      };
    }
    /**
     * Returns whether or not the button should render based on the operating environment and other factors.
     * ie. If your Authenticator App does not support mobile, it returns false when running in a mobile browser.
     */

  }, {
    key: "shouldRender",
    value: function shouldRender() {
      return !this.isLoading();
    }
    /**
     * Returns whether or not the dapp should attempt to auto login with the Authenticator app.
     * Auto login will only occur when there is only one Authenticator that returns shouldRender() true and
     * shouldAutoLogin() true.
     */

  }, {
    key: "shouldAutoLogin",
    value: function shouldAutoLogin() {
      return this.users.length > 0;
    }
    /**
     * Returns whether or not the button should show an account name input field.
     * This is for Authenticators that do not have a concept of account names.
     */

  }, {
    key: "shouldRequestAccountName",
    value: function shouldRequestAccountName() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", false);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
    /**
     * Login using the Authenticator App. This can return one or more users depending on multiple chain support.
     *
     * @param accountName  The account name of the user for Authenticators that do not store accounts (optional)
     */

  }, {
    key: "login",
    value: function login() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var identity;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.chains.length > 1)) {
                  _context3.next = 2;
                  break;
                }

                throw new UALAnchorError_1.UALAnchorError('UAL-Anchor does not yet support providing multiple chains to UAL. Please initialize the UAL provider with a single chain.', universal_authenticator_library_1.UALErrorType.Unsupported, null);

              case 2:
                _context3.prev = 2;

                if (!(this.users.length === 0)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 6;
                return this.link.login(this.appName);

              case 6:
                identity = _context3.sent;
                this.users = [new AnchorUser_1.AnchorUser(this.rpc, identity.session)];

              case 8:
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](2);
                throw new UALAnchorError_1.UALAnchorError(_context3.t0.message, universal_authenticator_library_1.UALErrorType.Login, _context3.t0);

              case 13:
                return _context3.abrupt("return", this.users);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 10]]);
      }));
    }
    /**
     * Logs the user out of the dapp. This will be strongly dependent on each Authenticator app's patterns.
     */

  }, {
    key: "logout",
    value: function logout() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this$users, user, auth;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // retrieve the current user
                _this$users = _slicedToArray(this.users, 1), user = _this$users[0]; // retrieve the auth from the current user

                auth = user.session.auth; // remove the session from anchor-link

                _context4.next = 4;
                return this.link.removeSession(this.appName, auth);

              case 4:
                // reset the authenticator
                this.reset();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Returns true if user confirmation is required for `getKeys`
     */

  }, {
    key: "requiresGetKeyConfirmation",
    value: function requiresGetKeyConfirmation() {
      return false;
    }
  }]);

  return Anchor;
}(universal_authenticator_library_1.Authenticator);

exports.Anchor = Anchor;